/**
 * author: wf
 * timer: 2021-01-18 11:25
 * 这个mixin是因为审批过到详情页后无法返回，replace不起作用 强制返回上两页
 */
export default {
  mounted () {
    if (window.history && window.history.pushState) {
    // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false)
  },

  methods: {
    goBack () {
      window.history.go(-2)
      history.pushState(null, null, document.URL)
    }
  }
}
